import { sbaasPreset } from '@swuif/sbaas';
import appLogo from '@/assets/logo_st_new.svg';
import antdEn from 'antd/es/locale-provider/en_US';
import antdId from 'antd/es/locale-provider/id_ID';
import i18n from './i18n';
import { authStorage } from './swuif';
import { RequestInterceptor } from 'frest';
import { keycloak } from '.';
// import { logoutKeycloak } from '@/components/utils';
import { logOutUser } from '@/clients/auth/samsungAccount';

/**
 * Create a preset for SBaaS consuming application.
 * `sbaasPreset` is for SBaaS version >= 1.0.0.
 * For SBaaS version < 1.0.0 use `sbaasLegacyPreset` instead.
 */

const REACT_APP_SBAAS_BASE = process.env.REACT_APP_SBAAS_BASE
  ? process.env.REACT_APP_SBAAS_BASE
  : '';
const REACT_APP_SBAAS_APP = process.env.REACT_APP_SBAAS_APP
  ? process.env.REACT_APP_SBAAS_APP
  : 'st-mdr';

const { app, http, sbaas } = sbaasPreset({
  sbaas: {
    base: process.env.REACT_APP_SBAAS_BASE || '',
    app: process.env.REACT_APP_SBAAS_APP || '',
  },
  auth: {
    storage: authStorage,
  },
  config: {
    app: {
      appName: 'Device Registration',
      appLogo,
    },
    locale: {
      i18n,
      fallbackLanguage: 'en',
      languageMeta: {
        en: {
          antd: antdEn,
          countryFlag: 'gb',
          label: 'English',
        },
        id: {
          antd: antdId,
          countryFlag: 'id',
          label: 'Bahasa Indonesia',
        },
      },
    },
  },
});

const { http: http_mdr_api, sbaas: sbaas_mdr_api } = sbaasPreset({
  sbaas: {
    base: REACT_APP_SBAAS_BASE,
    app: REACT_APP_SBAAS_APP,
  },
  auth: {
    storage: authStorage,
  },
  config: {
    app: {
      appName: 'SmartThings Analytics',
      appLogo,
    },
    locale: {
      i18n,
      fallbackLanguage: 'en',
      languageMeta: {
        en: {
          antd: antdEn,
          countryFlag: 'gb',
          label: 'English',
        },
      },
    },
  },
});

const expireMargin = 33;
const refreshToken = (request: any) => {
  return keycloak.refreshToken(expireMargin).then(refreshed => {
    if (refreshed) {
      //   console.warn('Token was successfully refreshed');
      // } else {
      //   console.warn('Token is still valid');
    }
    request.headers.set(
      'Authorization',
      `Bearer ${keycloak.instance.token}`, // newly refreshed token
    );
    return request;
  });
};

const customSbaasAuthRequestInterceptor = (): RequestInterceptor => ({
  request,
}) =>
  new Promise((resolve, reject) => {
    try {
      if (!keycloak.canRefresh()) {
        // need relogin
        logOutUser();
        return;
      }
      const exp = keycloak.getExpireIn();
      if (expireMargin > exp) {
        refreshToken(request)
          .then(resolve)
          .catch((e: any) => {
            // console.warn(['--- catch updateToken: ',err])
            if (!keycloak.canRefresh()) {
              logOutUser();
              return;
            }
            reject(e); // keycloak server is offline/busy?
          });
        return;
      } else {
        request.headers.set(
          'Authorization',
          `Bearer ${keycloak.instance.token}`,
        );
      }
      resolve(request);
    } catch (e) {
      reject(e);
    }
  });

http_mdr_api.interceptors.request.use(customSbaasAuthRequestInterceptor());

export { app, http, sbaas, sbaas_mdr_api };
